import { useState, React, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Stack,
  Typography,
  Box,
  Paper,
  TextField,
  Grid,
  Button,
} from "@mui/material";
import MuiButton from "../../components/muibutton";
import { getAPIwithParams, postAPI } from "../../services/basehttpAPI";
import SnackbarComponent from "../../components/snackbar";


const AddCustomer = () => {
  const navigate = useNavigate();
  const { custid } = useParams();
  const [custmodel, setcustmodel] = useState({
    id: 0,
    customername: null,
    indasCustomerId: null,
  });
  const [validcustname, setvalidcustname] = useState(null);
  const [validcustid, setvalidcustid] = useState(null);
  const [errorcustnametext, seterrorcustnametext] = useState(null);
  const [errorcustidtext, seterrorcustidtext] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
    const [severity, setseverity] = useState(null);
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  let pagename = null;
  let navigationUrl = null;
  let btnname = null;

  const getCustomerProfilebyId = async () => {
    if (custid !== undefined && custid !== 0) {
      let url = "CustomerProfile/GetCustomerProfileById";
      const custModel = {
        id: custid,
      };
      const response = await getAPIwithParams(url, custModel);
      setcustmodel({
        id: response.responseData.customerProfileId,
        customername: response.responseData.customerName,
        indasCustomerId: response.responseData.indasId,
      });
    }
  };

    if (custid) {
        pagename = translatedText.edit_customer_profile//"Edit Customer Profile";
    navigationUrl = `/layout/viewcustomer/${custid}`;
      btnname = translatedText.update_customer;
  } else {
        pagename = translatedText.add_customer_profile;//"Add Customer Profile";
    navigationUrl = `/layout/customerprofiles`;
        btnname = translatedText.create_customer;
  }

  useEffect(() => {
    getCustomerProfilebyId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
      seterrorcustnametext(validcustname ? translatedText.enter_indas_customer_name : null);
      seterrorcustidtext(validcustid ? translatedText.enter_indas_customer_id  : null);
  }, [validcustname, validcustid]);

  const handleClose = () => {
    setOpen(false);
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setcustmodel({
      ...custmodel,
      [evt.target.name]: value,
    });
  }

  function handleVaild(e) {
    if (e.target.value.trim() === "") {
      if (e.target.name === "indasCustomerId") {
        setvalidcustid(true);
      }
      if (e.target.name === "customername") {
        setvalidcustname(true);
      }
    } else {
      setvalidcustid(false);
      setvalidcustname(false);
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      custmodel.indasCustomerId !== null &&
      custmodel.customername !== null &&
      custmodel.indasCustomerId !== "" &&
      custmodel.customername !== ""
    ) {
      let url = "CustomerProfile/SaveCustomerProfile";
      const { data } = await postAPI(url, custmodel);
      if (data !== null) {
        if (data.isSuccess) {
            setseverity("success");
            setmessage(translatedText.saved_sucessfully);
          setOpen(true);
          navigate(navigationUrl);
        } else if (!data.isSuccess) {
          setseverity("error");
          setmessage(data.errorMessages);
          setOpen(true);
        } else {
          setseverity("error");
            setmessage(translatedText.something_went_wrong_please_try_again_sometime);
          setOpen(true);
        }
      } else {
        setseverity("error");
          setmessage(translatedText.something_went_wrong_please_try_again_sometime);
        setOpen(true);
      }
    } else {
      if (custmodel.indasCustomerId == null) {
        setvalidcustid(true);
      }
      if (custmodel.customername == null) {
        setvalidcustname(true);
      }
    }
  };
  const handleNavigation = () => {
    navigate(navigationUrl);
  }
  return (
    <Container maxWidth="lg" sx={{ mb: "50px" }}>
      <Typography variant="h5" flexGrow={1}>
        {pagename}
      </Typography>
      <Paper sx={{ width: "100%", height: "100%", mt: "20px" }}>
        <Box
          component="form"
          sx={{
            "& .MuiFormControl-root": {
              width: "90%",
            },
          }}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <Grid container>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <TextField
                margin="normal"
                              id="customername"
                              label={translatedText.customer_name}//"Customer Name"
                name="customername"
                autoComplete="off"
                required
                value={custmodel.customername || ""}
                onChange={handleChange}
                onBlur={handleVaild}
                error={errorcustnametext !== null ? true : false}
                helperText={errorcustnametext}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <TextField
                margin="normal"
                              id="indasCustomerId"
                              label={translatedText.indas_customer_id}//"Indas Customer ID"
                name="indasCustomerId"
                autoComplete="off"
                required
                value={custmodel.indasCustomerId || ""}
                onChange={handleChange}
                onBlur={handleVaild}
                error={errorcustidtext !== null ? true : false}
                helperText={errorcustidtext}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                style={{ display: "flex", justifyContent: "flex-end" }}
                marginRight={"30px"}
                marginTop={"10px"}
              >
                              <MuiButton
                                  text={translatedText.cancel}//"Cancel"
                  color="grey"
                  onClick={handleNavigation}
                  show = {true}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {" "}
                  {btnname}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Container>
  );
};

export default AddCustomer;
